import { Group, Intersection, Matrix4, Ray, Raycaster, Vector3 } from 'three';

import { Direction3D, Line3D, Plane3D, Point3D } from '@paragon/geometry-library';

const inverseMatrix = new Matrix4();
const threeRay = new Ray();
const target = new Vector3();

const designPlane = Plane3D.fromPerpendicularDirectionAndPoint(Direction3D.positiveZ, Point3D.origin);

/** To use, set `raycast={raycastReferenceLineContainer}`. */
export function raycastReferenceLineContainer(this: Group, raycaster: Raycaster, intersects: Intersection[]) {
  threeRay.copy(raycaster.ray);

  inverseMatrix.copy(this.matrixWorld).invert();
  threeRay.applyMatrix4(inverseMatrix);

  const geometryLibraryRay = new Line3D(
    Direction3D.fromObject(threeRay.direction)!,
    Point3D.fromObject(threeRay.origin),
  );

  const rayPlaneIntersection = designPlane.intersectWithLine(geometryLibraryRay);
  if (!rayPlaneIntersection) return;

  target.fromArray(rayPlaneIntersection.toArray()).applyMatrix4(this.matrixWorld);

  intersects.push({
    object: this,
    point: target.clone(),
    distance: target.distanceTo(threeRay.origin),
  });
}
